import { BaseApiService } from './base'

export interface HelpUrlsResponse {
  [key: string]: string
}

class HelpUrlsService extends BaseApiService {
  private helpUrls: HelpUrlsResponse = {}
  private loaded = false

  async loadHelpUrls(): Promise<HelpUrlsResponse> {
    if (this.loaded) {
      return this.helpUrls
    }

    try {
      const uiUrl = import.meta.env.VITE_UI_URL
      if (!uiUrl) {
        throw new Error('UI_URL environment variable is not configured')
      }

      const stageName = import.meta.env.VITE_STAGE_NAME
      const isProduction = stageName === 'production'
      const helpUrlsPath = isProduction ? '/assets/docs/helpUrls.json' : '/assets/docs/helpUrls-nonProd.json'

      // Construct the full URL
      const fullUrl = `${uiUrl}${helpUrlsPath}`

      // Fetch the help URLs
      const response = await fetch(fullUrl)
      if (!response.ok) {
        throw new Error(`Failed to load help URLs from ${fullUrl}: ${response.statusText}`)
      }

      this.helpUrls = await response.json()
      this.loaded = true

      return this.helpUrls
    } catch (error) {
      console.error('Error loading help URLs:', error)
      throw error
    }
  }

  async getHelpUrl(key: string): Promise<string | undefined> {
    const helpUrls = await this.loadHelpUrls()
    return helpUrls[key]
  }

  async getAllHelpUrls(): Promise<HelpUrlsResponse> {
    return this.loadHelpUrls()
  }

  reset(): void {
    this.helpUrls = {}
    this.loaded = false
  }
}

export const helpUrlsService = new HelpUrlsService()
